(function () {

  // Helper: Wait for Shopify.loadFeatures
  function waitForShopifyFeatures(callback, attempts = 0) {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      return callback();
    }
    if (attempts > 20) {
      return callback();
    }
    setTimeout(() => waitForShopifyFeatures(callback, attempts + 1), 200);
  }

  // Helper: Load Customer Privacy API
  function loadCustomerPrivacyApi(cb) {
    waitForShopifyFeatures(() => {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        return cb(window.Shopify.customerPrivacy);
      }

      window.Shopify?.loadFeatures?.(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error) {
            return cb(null);
          }
          cb(window.Shopify.customerPrivacy);
        }
      );
    });
  }

  // Helper: Debug current consent status
  function debugConsentState(api, label = 'Unknown') {
    if (!api) return;
    const state = {
      preferences: api.preferencesProcessingAllowed(),
      analytics: api.analyticsProcessingAllowed(),
      marketing: api.marketingAllowed(),
      sale_of_data: api.saleOfDataAllowed()
    };
    console.log(`Consent State [${label}]`, state);
  }

  // Helper: Map Cookiebot consent → Shopify
  function mapCookiebotToConsentObject() {
    const consent = (typeof Cookiebot !== 'undefined' && Cookiebot.consent) ? Cookiebot.consent : {};
    const mapped = {
      analytics: !!consent.statistics,
      marketing: !!consent.marketing,
      preferences: !!consent.preferences,
      sale_of_data: false,
    };
    return mapped;
  }

  // Apply consent to Shopify API
  function applyConsent(api, consentObj, source = 'unknown') {
    if (!api || typeof api.setTrackingConsent !== 'function') {
      return;
    }
    api.setTrackingConsent(consentObj, function () {
      debugConsentState(api, `After ${source}`);
    });
  }

  // Reset all consents (disable all)
  function resetConsent(api, source = 'reset') {
    const resetObj = {
      analytics: false,
      marketing: false,
      preferences: false,
      sale_of_data: false,
    };
    applyConsent(api, resetObj, source);
  }

  // Main initializer
  function initConsentSync() {
    loadCustomerPrivacyApi(function (api) {
      if (!api) {
        return;
      }

      // Reset at page load
      resetConsent(api, 'pageload');

      // Cookiebot dialog
      window.addEventListener('CookiebotOnDialogDisplay', function () {
        resetConsent(api, 'OnDialogDisplay');
      });

      window.addEventListener('CookiebotOnConsentReady', function () {
        const consent = mapCookiebotToConsentObject();
        applyConsent(api, consent, 'OnConsentReady');
      });

      window.addEventListener('CookiebotOnAccept', function () {
        const consent = mapCookiebotToConsentObject();
        applyConsent(api, consent, 'OnAccept');
      });

      window.addEventListener('CookiebotOnDecline', function () {
        resetConsent(api, 'OnDecline');
      });

      window.addEventListener('visitorConsentCollected', function (e) {
        debugConsentState(api, 'visitorConsentCollected');
      });

      debugConsentState(api, 'Initial Load');
    });
  }

  // Expose for external testing
  window.__ConsentSyncInit = initConsentSync;

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConsentSync);
  } else {
    initConsentSync();
  }
})();
  
// Trigger when document becomes interactive
document.onreadystatechange = () => {
  if (document.readyState === "interactive") {
    window.__ConsentSyncInit();
  }
};
